import { reclaim } from "../reclaim-api";
import { makeLoadableHook } from "../utils/react";

export const useEntitlementTable = makeLoadableHook(() => reclaim.team.getEntitlementTable(), {
  dataKey: "entitlementTable",
  errorizer: "Failed to get entitlement table",
}).useHook;
